import React from 'react';

const Speaker = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.328 2.65c.458-.352 1.002-.638 1.583-.392.576.243.76.83.84 1.406.082.591.082 1.405.082 2.417V9.92c0 1.012 0 1.826-.081 2.417-.08.576-.265 1.163-.84 1.406-.582.246-1.126-.04-1.584-.391-.469-.36-1.033-.936-1.733-1.651l-.03-.031c-.36-.368-.599-.545-.84-.645-.244-.1-.539-.143-1.054-.143h-.026c-.446 0-.819 0-1.12-.031-.317-.033-.611-.105-.876-.285-.503-.344-.696-.848-.77-1.31C.826 8.91.832 8.53.837 8.225a14 14 0 0 0 0-.451C.831 7.469.826 7.09.88 6.745c.073-.463.266-.966.77-1.31.264-.18.558-.252.874-.285.302-.031.675-.03 1.12-.03h.027c.515 0 .81-.044 1.053-.144s.48-.277.84-.645l.031-.031c.7-.715 1.264-1.291 1.733-1.65m.609.792c-.405.312-.92.836-1.658 1.59-.393.4-.744.691-1.173.868-.427.177-.88.22-1.435.22-.479 0-.8 0-1.043.025-.235.024-.343.068-.415.116-.194.133-.297.332-.346.64-.04.25-.035.509-.03.8L1.838 8q0 .156-.003.3c-.004.29-.008.548.031.799.049.308.152.507.346.64.072.048.18.091.415.116.244.025.564.026 1.043.026.554 0 1.008.042 1.435.219.429.177.78.468 1.173.869.738.753 1.253 1.277 1.658 1.588.422.325.549.28.585.264.041-.017.165-.086.239-.622.071-.515.072-1.258.072-2.323V6.124c0-1.065 0-1.809-.072-2.323-.074-.537-.198-.605-.24-.622-.035-.016-.162-.061-.584.263"
      fill="#7E7572"
    />
    <path
      d="M11.03 5.602a.5.5 0 0 1 .7.095c.483.632.77 1.434.77 2.303s-.287 1.67-.77 2.303a.5.5 0 0 1-.794-.606A2.8 2.8 0 0 0 11.5 8a2.8 2.8 0 0 0-.564-1.697.5.5 0 0 1 .094-.7m2.672-1.274a.5.5 0 1 0-.737.675c.757.828 1.202 1.87 1.202 2.996s-.445 2.168-1.202 2.996a.5.5 0 1 0 .737.675c.91-.994 1.465-2.272 1.465-3.671s-.555-2.677-1.465-3.671"
      fill="#7E7572"
    />
  </svg>
);

export default Speaker;
